<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'pieChart',
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        },
        showLegend:{
            type:Boolean,
            default: true,
        },
        legName:{
            type:String,
            default:function(){
                return '';
            }
        },
        colorArr:{
            type: Array,
            default: function () {
                return ["#30d258","#e52e45","#f76a44","#ff8121","#2475fb","#1abbf0","#7b37c8","#6a4f77","#c28000","#7dbf2e","#18c391","#4b8abb","#539e79","#d216d2","#bb0000"]
            }
        }
    },
    mounted() {
        let that = this;
        that.init();
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        // 位置
        positionData () {
            let that = this;
            let num = '';
            num = that.showLegend == true ? '50%' : '50%';
            return num;
        },
        pieOption:function(){
            let _this = this;
            var option = {
                title: {
                    text: _this.legName,
                    top:'center',
                    left:'center',
                    textStyle: {
                        color: '#3d3d4c',
                        fontSize:22
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{b}: {c} ({d}%)",
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show:false
                        }
                    }
                },
                color:_this.colorArr,
                
                legend: {
                    show:_this.showLegend,
                    orient : 'horizontal',
                    bottom:'2%',
                    x: 'center',
                    itemGap: 10,
                    textStyle:{
                        color:'#4c4c4c'
                    },
                },
                series: [{
                        name:'',
                        type: 'pie',
                        startAngle:0,
                        center:[_this.positionData(), '50%'],
                        radius: ['32%', '50%'],
                        label: {
                            normal: {
                                formatter: "{b} {d}%",
                                textStyle: {
                                    //color:'rgba(255,255,255,.7)',
                                    fontSize:14
                                },
                            },
                        },
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    formatter : function (params) {                         
                                        return (params.percent - 0).toFixed(2) + '%'
                                    },
                                },
                                shadowBlur: 20,
                                shadowOffsetY: 4,
                                shadowColor: 'rgba(6, 69,147, 0.3)'
                            }
                        },
                        data:_this.dataArray
                    }
                ]
            }
            return option;
        },
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            _this.chart.setOption(_this.pieOption());
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/pieChart.vue